import { ChevronRightIcon } from '@heroicons/react/24/outline';
import { formatScanDate, scanTakenAt } from '@odo/shared-ui';
import type { RejectedScan } from '../../../services/dmRejectedScans';
import {
    REVIEW_LABELS,
    rejectionReasonLine,
    scanPhotoSummary,
    scanTypeLabel
} from './rejectedScanText';

function RejectedScanHeading({ scan }: { scan: RejectedScan }) {
    const typeLabel = scanTypeLabel(scan.type);
    return (
        <span className="flex flex-wrap items-center gap-2">
            <span className="text-sm font-bold text-gray-800">
                {formatScanDate(scanTakenAt(scan))}
            </span>
            {typeLabel && <span className="text-sm font-semibold text-gray-500">{typeLabel}</span>}
            <span className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-md text-[11px] font-semibold bg-gray-100 text-gray-500">
                <span className="w-1.5 h-1.5 rounded-full bg-current opacity-70" />
                {REVIEW_LABELS[scan.review]}
            </span>
            {scan.alignerIndex != null && (
                <span className="text-xs font-medium text-gray-500">
                    Aligner {scan.alignerIndex}
                </span>
            )}
        </span>
    );
}

interface RejectedScanCardProps {
    scan: RejectedScan;
    onOpen: (scanId: number) => void;
}

function RejectedScanCard({ scan, onOpen }: RejectedScanCardProps) {
    const reasons = rejectionReasonLine(scan.reasons);
    return (
        <button
            type="button"
            onClick={() => onOpen(scan.scanId)}
            className="flex w-full items-center gap-4 rounded-xl border border-gray-200 p-4 text-left hover:border-gray-300 hover:bg-gray-50 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-400"
        >
            <span className="flex min-w-0 flex-1 flex-col gap-1.5">
                <RejectedScanHeading scan={scan} />
                {reasons && <span className="text-sm text-gray-700">{reasons}</span>}
                <span className="text-xs text-gray-500">{scanPhotoSummary(scan)}</span>
            </span>
            <ChevronRightIcon className="h-5 w-5 shrink-0 text-gray-400" />
        </button>
    );
}

export { RejectedScanCard, RejectedScanHeading };
